import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
const section = document.querySelector('.trusted-by-section');

export const initVideoSwiper = () => {
  const sliders = section?.querySelectorAll('.trusted-by__container');
  if (!sliders) return;
  sliders?.forEach((slider) => {
    const swiperOptions = {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: false,
      watchOverflow: true,
      breakpoints: {
        375: {
          slidesPerView: 1.7409,
          spaceBetween: 24,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 28,
        },
        1280: {
          slidesPerView: 4.1777,
          spaceBetween: 32,
        },
      },
      on: {
        afterInit: function () {
          slider
            .querySelector('.trusted-by__wrapper')
            ?.classList.remove('gap-6', 'lg:gap-7', 'xl:gap-8');
        },
      },
    };
    new Swiper(slider, swiperOptions);
  });
};

export const initStartVideo = () => {
  if (!section) return;
  const videos = section?.querySelectorAll(
    '.trusted-by__video-container video',
  );
  let timeout;

  section.querySelectorAll('.trusted-by__play-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const videoContainer = btn.closest('.trusted-by__video-container');
      const video = videoContainer.querySelector('video');
      const productInfo = videoContainer
        ?.closest('.trusted-by__slide')
        .querySelector('.product-info');
      videos.forEach((videoElement) => {
        if (videoElement !== video) {
          videoElement.pause();
          videoElement
            .closest('.trusted-by__video-container')
            .classList.remove('playing');
          clearTimeout(timeout);
        }
      });

      if (video.paused) {
        video.play();
        videoContainer.classList.add('playing');

        timeout = setTimeout(() => {
          productInfo?.classList.remove('hidden');
        }, 5000);
      }
    });
  });

  section.querySelectorAll('.trusted-by__pause-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const videoContainer = btn.closest('.trusted-by__video-container');
      const video = videoContainer.querySelector('video');

      if (!video.paused) {
        video.pause();
        videoContainer.classList.remove('playing');
        clearTimeout(timeout);
      }
    });
  });

  videos.forEach((video) => {
    video.addEventListener('ended', function () {
      const videoContainer = this.closest('.trusted-by__video-container');
      const productInfo = videoContainer
        ?.closest('.trusted-by__slide')
        .querySelector('.product-info');
      videoContainer.classList.remove('playing');
      productInfo?.classList.add('hidden');
      clearTimeout(timeout);
    });
  });
};
